import React from "react";
import RouterExport from "./components/routers/routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { i18nInit } from "./components/utils/i18n";
import { I18nextProvider } from "react-i18next";

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 0,
        staleTime: 5 * 60 * 1000, // 5 min
      },
    },
  });
  const i18next = i18nInit();

  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18next}>
        <RouterExport />
      </I18nextProvider>
    </QueryClientProvider>
  );
}

export default App;
